import './InfoDialog.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton } from '@fluentui/react';
import { InternalDialogContent } from './InternalDialogContent';
import { isValidElement } from 'react';

export interface InfoDialogProps {
  title: string;
  subText?: string | JSX.Element;
}

export class InfoDialog {
  public static show(options: InfoDialogProps) {
    const dialogNode = document.createElement('div');
    const close = (): void => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<InfoDialogInternal {...options} close={close} />, dialogNode);
  }
}

class InfoDialogInternal extends React.Component<InfoDialogProps & { close: () => void }> {
  public render(): JSX.Element {
    const { title, subText } = this.props;

    const hasStyledSubText = isValidElement(subText);

    const dialogContentProps: IDialogContentProps = {
      type: DialogType.normal,
      title: hasStyledSubText ? InternalDialogContent(title, subText as JSX.Element) : title,
      subText: hasStyledSubText || !subText ? undefined : (subText as string),
    };

    return (
      <Dialog
        hidden={false}
        dialogContentProps={dialogContentProps}
        onDismiss={this.ok}
        modalProps={{
          isBlocking: true,
          className: 'info-dialog',
        }}
      >
        <DialogFooter>
          <PrimaryButton onClick={this.ok}>Ok</PrimaryButton>
        </DialogFooter>
      </Dialog>
    );
  }

  private ok = () => {
    this.props.close();
  };
}
